<template>
  <div>
    <Head title="Update Asset Group" />
    <h1 class="mb-8 text-3xl font-bold">
      Inventaris
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/asset_groups">
        Asset Group
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> {{ props.assetGroup.name }}
    </h1>
    <tab-view tab-name-01="Update Data Group" tab-name-02="Summary Asset Group">
      <template #tabContent01>
        <form @submit.prevent="update">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input
              v-model="form.name"
              :error="form.errors.name"
              class="pb-8 pr-6 w-1/2"
              label="Nama Group" />
            <select-input
              v-model="form.item_location_id"
              :error="form.errors.item_location_id"
              class="pb-8 pr-6 w-full md:w-1/3"
              label="Lokasi Item">
              <option
                v-for="itemLocation in itemLocations"
                :key="itemLocation.id"
                :value="itemLocation.id">
                {{ itemLocation.name }}
              </option>
            </select-input>
            <textarea-input
              rows="4"
              v-model="form.description"
              :error="form.errors.description"
              label="Deskripsi Asset Group"
              class="pb-8 pr-6 w-full md:w-1/2" />
          </div>
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button
              :loading="form.processing"
              class="btn-indigo"
              type="submit">
              Update Asset Group
            </loading-button>
          </div>
        </form>
      </template>
      <template #tabContent02>
        <table class="w-full whitespace-nowrap">
          <thead>
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6">
                Nama Barang
              </th>
              <th class="pb-4 pt-6 px-6 text-right">
                Subtotal Qty
              </th>
              <th class="pb-4 pt-6 px-4" colspan="2">
                Last Updated
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="detail in assetGroupDetails.data"
              :key="detail.id"
              class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="px-4 py-2 border-t">
                {{ detail.name }}
              </td>
              <td class="px-4 py-2 text-right border-t">
                {{ detail.qty }}
              </td>
              <td class="px-4 py-2 border-t">
                {{ detail.updated_at }}
              </td>
            </tr>
            <tr v-if="assetGroupDetails.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="3">
                No Detail found.
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </tab-view>
    <h2 class="my-4 text-2xl font-bold">
      Group Member
    </h2>
    <div class="my-4 max-w-3xl bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="p-4">
              Nama Asset
            </th>
            <th class="p-4 text-center">
              No.Inventaris
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="member in assetGroupMembers.data"
            :key="member.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="px-4 py-2 border-t">
              {{ member.name }}
            </td>
            <td class="flex justify-end px-4 py-2 border-t">
              {{ member.asset_no }}
              <button
                title="Keluarkan asset dari member group"
                type="submit"
                class="-mt-1"
                @click.prevent="removeMember(member.id)">
                <Icon icon="ic:baseline-delete" class="block mx-4 w-6 h-6 fill-red-500" />
              </button>
            </td>
          </tr>
          <tr v-if="assetGroupMembers.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="2">
              No Member found.
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div class="flex justify-center px-2 py-4 max-w-2xl">
                <v-select
                  v-model="formMember.item_asset_id"
                  class="flex-grow focus:text-indigo-500"
                  :class="{ error: form.errors.mst_item_id }"
                  placeholder="[Pilih Asset Inventaris untuk ditambahkan]"
                  label="name"
                  :reduce="(option) => option.id"
                  :filterable="false"
                  :options="itemOptions"
                  :append-to-body="true"
                  @search="onSearch" />
                <button
                  title="Tambahkan asset sebagai member group"
                  type="submit"
                  @click.prevent="addMember">
                  <Icon icon="icon-park:add-one" class="block mx-4 w-6 h-6 fill-indigo-600" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="assetGroupMembers.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue'

export default {
    layout: Layout,
}
</script>

<script setup>
import { Head, Link, useForm, router } from '@inertiajs/vue3'
import { defineProps, ref } from 'vue'
import { Icon } from '@iconify/vue'
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import Pagination from '@/Shared/Pagination.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import TabView from './TabView.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { throttle } from 'lodash'

const props = defineProps({
    itemLocations: Array,
    assetGroup: Object,
    assetGroupMembers: Object,
    assetGroupDetails: Object,
})

const form = useForm({
    ...props.assetGroup,
})

const formMember = useForm({
    item_asset_id: null,
})

const itemOptions = ref([])

const update = () => {
    form.put(`/asset_groups/${props.assetGroup.id}`, {
        preserveScroll: true,
    })
}

const addMember = () => {
    formMember.post(`/asset_groups/${props.assetGroup.id}/member`, {
        preserveScroll: true,
        onSuccess: () => {
            formMember.reset()
            itemOptions.value = []
        },
    })
}

const removeMember = (id) => {
    router.delete(`/asset_groups/${props.assetGroup.id}/member/${id}`, {
        preserveScroll: true,
    })
}

const fetchItemOptions = throttle((loading, search) => {
    fetch(`/item_assets?options=1&group_id=none&search=${escape(search)}`).then((res) => {
        res.json().then((json) => (itemOptions.value = json.itemAssetOptions))
        loading(false)
    })
}, 500)

function onSearch (search, loading) {
    if (search.length) {
        loading(true)
        fetchItemOptions(loading, search)
    }
}
</script>

<style scoped>
.v-select {
  --vs-line-height: 1.85;
}
</style>
